import { types, getRoot } from 'mobx-state-tree'
import type { IAlertMessages } from '../AlertMessage'

export const Alertable = types
  .model({})
  .views((self) => ({
    get alertMessages() {
      const { alertMessages } = getRoot(self) as { alertMessages: IAlertMessages }
      return alertMessages
    }
  }))
  .actions((self) => ({
    showAlert(message: string) {
      self.alertMessages?.showAlert(message)
    }
  }))
